/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * GeoJSON representation of the route
 * @export
 * @interface RouteResponseRoute
 */
export interface RouteResponseRoute {
    /**
     * Type of geometry (e.g., LineString)
     * @type {string}
     * @memberof RouteResponseRoute
     */
    type?: string;
    /**
     * Array of latitude and longitude coordinate pairs
     * @type {Array<Array<number>>}
     * @memberof RouteResponseRoute
     */
    coordinates?: Array<Array<number>>;
}

/**
 * Check if a given object implements the RouteResponseRoute interface.
 */
export function instanceOfRouteResponseRoute(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RouteResponseRouteFromJSON(json: any): RouteResponseRoute {
    return RouteResponseRouteFromJSONTyped(json, false);
}

export function RouteResponseRouteFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteResponseRoute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
    };
}

export function RouteResponseRouteToJSON(value?: RouteResponseRoute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
    };
}

